<template>
  <v-menu
    offset-y
    origin="center center"
    :nudge-bottom="10"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-list class="profile-list d-flex align-right">
        <v-list-item v-on="on" class="profile-section">
          <v-list-item-avatar>
            <v-avatar size="36" elevation="2">
              <img
                :src="profilePicture"
                class="profile-image"
                v-if="profilePicture"
              />
              <v-icon size="30" color="#000" v-else>mdi-account-outline</v-icon>
            </v-avatar>
            <!-- <img :src="profilePicture" class="mdi-icon-style-2" /> -->
            <!-- <v-icon size="30" color="#000">mdi-account-outline</v-icon> -->
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title> </v-list-item-title>
            <v-list-item-subtitle>
              <p class="mb-0 username-label">
                Welcome {{ name }}

                <!-- Welcome Jessie -->
              </p>
              <p class="mb-0 company-label">
                <span v-if="roles != 'Customer'"> {{ companyName }}</span>

                <!-- PNW Contracting -->
              </p>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-list
      class="pa-0 cust_profile"
      v-if="roles != 'Customer' && roles != 'Contractor' && roles != 'OEM'"
    >
      <v-list-item class="address">
        <v-list-item-content>
          <!-- Acct# {{ accNo }}
          <br />

          {{ addressText }} -->
          {{ fullname }}
          <br />
          {{ user }}
        </v-list-item-content>
      </v-list-item>
      <v-divider class="cust-border"></v-divider>

      <v-list-item
        v-for="(item, index) in menuitems"
        :key="index"
        ripple="ripple"
        :disabled="item.disabled"
        :target="item.target"
        rel="noopener"
        @click="item.click"
      >
        <v-list-item-action v-if="item.icon == 'mdi-account'">
          <v-avatar size="26px">
            <img v-if="avatar.imageURL" :src="avatar.imageURL" alt="name" />
            <img
              v-else
              src="../../assets/profile-icon.svg"
              class="mdi-icon-style-2 cust_img_change"
            />
          </v-avatar>
        </v-list-item-action>
        <v-list-item-action v-else>
          <v-icon color="#fff">{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="menu-title" v-if="item.title == 'Support'">
            {{ item.title
            }}<v-icon class="ml-2" color="#fff"
              >mdi-open-in-new</v-icon
            ></v-list-item-title
          >

          <v-list-item-title class="menu-title" v-else>
            {{ item.title }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- menuitems_Cus && Vendor -->
    <v-list class="pa-0 cust_profile" v-else>
      <v-list-item
        v-for="(item, index) in menuitems_Cus_Vendor"
        :key="index"
        ripple="ripple"
        :disabled="item.disabled"
        :target="item.target"
        rel="noopener"
        @click="item.click"
      >
        <v-list-item-action v-if="item.icon == 'mdi-account'">
          <v-avatar size="26px">
            <img v-if="avatar.imageURL" :src="avatar.imageURL" alt="name" />
            <img
              v-else
              src="../../assets/profile-icon.svg"
              class="mdi-icon-style-2 cust_img_change"
            />
          </v-avatar>
        </v-list-item-action>
        <v-list-item-action v-else>
          <v-icon color="#fff">{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <!-- <v-list-item-title class="menu-title">
            {{item.title}}</v-list-item-title> -->
          <v-list-item-title class="menu-title" v-if="item.title == 'Support'">
            {{ item.title
            }}<v-icon class="ml-2" color="#fff"
              >mdi-open-in-new</v-icon
            ></v-list-item-title
          >

          <v-list-item-title class="menu-title" v-else>
            {{ item.title }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<style scoped lang="scss">
@import "../../assets/styles/variables.scss";
.profile-list {
  padding: 0 !important;
  background: transparent !important;
}
.profile-list > .v-list-item {
  padding: 0px 0px;
}
.address {
  font-size: 15px !important;
  padding-bottom: 0 !important;
  padding-top: 0px !important;
}
.mdi-icon-style {
  font-size: 22px !important;
}
.mdi-icon-style-2 {
  height: 20px;
}
.profile-section {
  // padding: 0px;
  // width: 210px;
  width: 158px;
}
.v-menu__content {
  top: 64px !important;
  background-color: #363636 !important;
}
.v-list-item__avatar {
  margin-right: 5px !important;
  // filter: invert(1);
}

.v-list-item__action {
  margin-right: 10px !important;
}
.username-label {
  // color: $black-shade-4;
  //color:$neutral-white;
  color: black;
  font-weight: 700;
}
.company-label {
  // color: $neutral-gray-7;
  //color:$neutral-white;
  color: black;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.menu-title {
  height: 24px;
}
.cust_profile {
  background-color: #363636 !important;
  opacity: 0.8;
}
.cust_img_change {
  filter: invert(1);
}
.cust_profile .v-list-item__content,
.mdi-lock-outline,
.mdi-exit-to-app {
  color: white !important;
}
hr.cust-border.v-divider.theme--light {
  border-color: rgba(255, 255, 255, 0.5) !important;
}
.profile-image {
  height: 100%;
  width: auto;
}
</style>
<script>
import { mapGetters } from "vuex";
import apiService from "../../api/api.service";
// import EventBus from "../../utils/EventBus";
export default {
  name: "AppProfile",
  data() {
    return {
      result: [],
      isAvatar: false,
      isProfile: false,
      avatar: {
        imageURL: null,
      },
      menuitems: [
        {
          icon: "mdi-account",
          title: "Profile",
          click: () => {
            this.$router
              .push({
                path: "/user-profile",
              })
              .catch(() => {});
          },
        },
        // {
        //   icon: "mdi-bug",
        //   title: "Support",
        //   click: () => {
        //     this.$router
        //       .push({
        //         path: "/support-tickets"
        //       })
        //       .catch(() => {});
        //   }
        // },

        {
          icon: "mdi-lock-outline",
          title: "Change Password",
          click: () => {
            this.$router
              .push({
                path: "/change-password",
              })
              .catch(() => {});
          },
        },
        {
          icon: "mdi-help",
          title: "Support",
          click: () => {
            this.navigateSupportPortal();
          },
        },
        {
          icon: "mdi-exit-to-app",
          href: "#",
          title: "Logout",
          click: () => {
            this.logout();
          },
        },
      ],
      menuitems_Cus_Vendor: [
        {
          icon: "mdi-account",
          title: "Profile",
          click: () => {
            this.$router
              .push({
                path: "/user-profile",
              })
              .catch(() => {});
          },
        },

        {
          icon: "mdi-lock-outline",
          title: "Change Password",
          click: () => {
            this.$router
              .push({
                path: "/change-password",
              })
              .catch(() => {});
          },
        },
        {
          icon: "mdi-help",
          title: "Support",
          click: () => {
            this.navigateSupportPortal();
          },
        },
        {
          icon: "mdi-exit-to-app",
          href: "#",
          title: "Logout",
          click: () => {
            this.logout();
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "name",
      "fullname",
      // 'avatar',
      "status",
      "roles",
      "addressText",
      "accNo",
      "companyName",
      "lastLoginTime",
      "profilePicture",
    ]),
  },
  mounted() {
    this.userId = this.$store.getters.userId;
    // this.getProfileById();
  },
  methods: {
    logout() {
      this.$store.dispatch("LogOut");
      this.$router.push("/signin");
    },
    async getProfileById() {
      this.isProfile = true;
      try {
        this.result = await apiService.getProfile(this.userId);
        if (this.result.image) {
          this.avatar.imageURL = this.result.image;
        }
        this.isProfile = false;
      } catch (err) {
        this.isProfile = false;
        this.$toast.error("Unable to load the report requests" + err);
      }
    },
    navigateSupportPortal() {
      if (this.roles != "Customer") {
        window.open("https://support.incus5.com/", "_blank");
      } else if (this.roles == "Customer") {
        window.location = "mailto:maxx@birchequipment.com";
      }
    },
  },
};
</script>
